import { createApp, h } from 'vue';
import { RouterView } from 'vue-router';
import VueKonva from 'vue-konva';
import VueUnleash from './unleashPlugin';
// @ts-expect-error vue-matomo doesn't have type definitions
import VueMatomo from 'vue-matomo';
import router from './router';
import store from './store';
import axios from 'axios';

import GameStateStore from '../store/GameStateStore';
import actions from '../core/ruleset/experiment/actions';

import 'bootstrap/dist/css/bootstrap.css';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

// TODO #751: aliased in vue.config.js/.eslintrc.js because the package's style.css export is broken.
import '@mythictable/sheets/style.css';
import { registerDefaultTemplate, mythicTableLegacy } from '@mythictable/sheets';

import { VueFinderPlugin } from 'vuefinder';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faKickstarterK } from '@fortawesome/free-brands-svg-icons';
import {
    faDiceD20,
    faPencilAlt,
    faExchangeAlt,
    faTrash,
    faCode,
    faThumbtack,
    faArrowUp,
    faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';

import '@/common/assets/main.scss';
import '@/common/assets/modal.scss';
import '@/common/assets/tooltip.scss';
import '@/common/assets/icons.css';

import '@/common/assets/scrollbar.css';

// FIXME: find a better place to load in the ruleset than main.ts
const ruleset = {
    actions: actions,
};
(GameStateStore.state as any).ruleset = ruleset;

library.add(faKickstarterK);
library.add(faDiceD20);
// ActionMenu icons (library context menu, character editor)
library.add(faPencilAlt, faExchangeAlt, faTrash, faCode, faThumbtack, faArrowUp, faEyeSlash);

registerDefaultTemplate(mythicTableLegacy);

const app = createApp({
    render: () => h(RouterView),
});

app.use(store);
app.use(router);
app.use(VueKonva);
app.use(FloatingVue);
app.use(VueFinderPlugin);
app.use(VueMatomo, {
    host: 'https://mythictable.matomo.cloud/',
    siteId: 1,
    router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    trackerFileName: 'matomo',
    debug: true,
});
app.component('FaIcon', FontAwesomeIcon);
app.use(VueUnleash, {
    appName: process.env.VUE_APP_FEATURE_FLAG_NAME,
    host: 'https://gitlab.com/api/v4/feature_flags/unleash/14052249',
    instanceId: 'NZMy_McbTgHfknzonaEj',
    store,
    provider: 'gitlab',
});

app.mount('#app');

// TODO: Restrict this to only add the token if requesting from the original domain
// (so we don't send our SECRET auth token to other websites accidentally)
axios.interceptors.request.use(
    (config: any) => {
        if (!(Object.prototype.hasOwnProperty.call(config, 'disableAuth') && config.disableAuth)) {
            const accessToken = (store.state as any).oidcStore?.access_token;
            if (accessToken) {
                config.headers['Authorization'] = `Bearer ${accessToken}`;
            } else if (config.headers && config.headers['Authorization']) {
                delete config.headers['Authorization'];
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);
